<script lang="ts">
    import {_} from 'svelte-i18n'
    import {createEventDispatcher} from 'svelte';
    import Textfield from '@smui/textfield';
    import HelperText from '@smui/textfield/helper-text';
    import CharacterCounter from '@smui/textfield/character-counter';
    import IconButton from '@smui/icon-button';
    import EmojiPicker from './EmojiPicker.svelte';
    import PredefinedMessagePicker from './PredefinedMessagePicker.svelte';
    import type {DefinedMessageType} from './types';
    import {tick} from 'svelte/internal';

    const dispatch = createEventDispatcher();

    export let disabled: boolean = false;
    export let value: string = '';
    export let valueValid: boolean = false;
    export let placeholder: string = 'Napište zprávu';
    export let predefinedMessagesType: DefinedMessageType;

    let textfieldElement: HTMLTextAreaElement;
    let emojiSelectionShowed: boolean = false;
    let predefinedMessageSelectionShowed: boolean = false;
    let emojis = ['🙁', '😒', '😢', '🤔', '🙄', '😨', '😡', '😣', '🥱', '🤒', '🤕', '😮', '😱', '🥶', '🥵', '🤢', '🙂', '😉', '😀'];

    const infixToEmojisMap = {
        ':-)': '🙂',
        ':)': '🙂',
        ':-D': '😀',
        ':D': '😀',
    };

    const MESSAGE_MAX_LENGTH = 2000;

    $: {
        valueValid = value.trim().length > 0 && value.length <= MESSAGE_MAX_LENGTH;
        for (let latin in infixToEmojisMap) {
            if (value.indexOf(latin) !== -1) {
                value = value.replace(latin, infixToEmojisMap[latin]);
            }
        }
    }

    function submitMessage() {
        if (!valueValid) {
            return;
        }
        dispatch('message-submit');
        textfieldElement.focus();
    }

    function insertNewLine(eventTextareaElement: HTMLTextAreaElement) {
        const cursorPosition = eventTextareaElement.selectionStart;
        value = `${value.substring(0, cursorPosition)}\n${value.substring(cursorPosition)}`;
        tick().then(() => eventTextareaElement.setSelectionRange(cursorPosition + 1, cursorPosition + 1));
    }

    function handleKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            if (event.ctrlKey) {
                insertNewLine(<HTMLTextAreaElement>event.target);
            } else {
                event.preventDefault();
                submitMessage();
            }
        }
    }

    function handleEmojiPicked(event: CustomEvent<string>) {
        value += event.detail;
        textfieldElement.focus();
    }

    function handlePredefinedMessagePicked(event: CustomEvent<string>) {
        value = event.detail;
        textfieldElement.focus();
    }
</script>


<div style="width: 100%; display: flex; box-sizing: border-box;">
    <IconButton class="material-icons" on:click={() => emojiSelectionShowed = !emojiSelectionShowed} title="Emoji" disabled={disabled}>emoji_emotions</IconButton>
    {#if predefinedMessagesType}
        <IconButton class="material-icons" on:click={() => predefinedMessageSelectionShowed = !predefinedMessageSelectionShowed} title={$_('message.PredefinedMessages')} disabled={disabled}>chat</IconButton>
    {/if}
    <div style="width: 100%; display: flex; flex-direction: column; align-items: center;">
        <div style="width: 100%;">
            <Textfield
                    textarea
                    bind:value
                    bind:this={textfieldElement}
                    disabled={disabled}
                    on:keydown={handleKeydown}
                    label={placeholder}
                    input$maxlength={MESSAGE_MAX_LENGTH}
                    style="width: 100%;"
                    helperLine$style="width: 100%;">
                <HelperText slot="helper" style="width: 100%; display: flex; justify-content: space-between;">
                    <div>{$_('commons.Hint')}: {$_('message.pressForNewLine')} CTRL+ENTER</div>
                    <div><CharacterCounter/></div>
                </HelperText>
            </Textfield>
        </div>
        {#if emojiSelectionShowed}
            <div>
                <EmojiPicker emojis={emojis} on:emoji-selected={handleEmojiPicked} />
            </div>
        {/if}
        {#if predefinedMessagesType && predefinedMessageSelectionShowed}
            <div>
                <PredefinedMessagePicker type={predefinedMessagesType} on:predefined-message-selected={handlePredefinedMessagePicked} />
            </div>
        {/if}
    </div>
</div>